import { useParams, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import SEOHead from "@/components/feature/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { categories, categoryMap } from "@/mocks/categories";

interface ArticleCardData {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  date: string;
  readTime: number;
  tags: string[];
  imageUrl: string;
}

const articleDataByCategory: Record<string, ArticleCardData[]> = {
  tutorial: [
    {
      id: "art-1",
      title: "JM网页版官网入口 - 最新官方直达通道使用指南",
      slug: "jm-official-entry-guide",
      excerpt: "本文详细介绍JM网页版官网入口的最新使用方式，包括如何找到官方入口、注册登录流程、以及使用过程中的注意事项，帮助您安全稳定地访问JM平台。",
      date: "2026-08-08",
      readTime: 8,
      tags: ["JM网页版官网入口", "JM官网入口", "JM网页版登录", "JM官方入口"],
      imageUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20laptop%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20soft%20neutral%20colors%2C%20professional%20photography&width=800&height=400&seq=cat-tut-art1&orientation=landscape",
    },
    {
      id: "art-7",
      title: "新手必读：JM网页版注册与首次使用完整流程",
      slug: "jm-web-registration-guide",
      excerpt: "面向新用户的JM网页版注册与首次使用完整指南，从注册到熟悉各项功能，助你快速上手。",
      date: "2026-07-20",
      readTime: 6,
      tags: ["JM网页版官网入口", "JM网页版登录", "JM注册教程"],
      imageUrl: "https://readdy.ai/api/search-image?query=Person%20typing%20on%20laptop%20keyboard%2C%20warm%20cozy%20environment%2C%20soft%20natural%20lighting%2C%20minimalist%20desk%20setup%2C%20clean%20modern%20aesthetic&width=800&height=400&seq=cat-tut-art7&orientation=landscape",
    },
  ],
  news: [
    {
      id: "art-2",
      title: "JM网页版最新入口地址更新公告（2026年8月）",
      slug: "jm-latest-entry-update-august-2026",
      excerpt: "JM网页版官方发布最新入口地址更新公告，确保用户能够安全稳定地访问JM平台。本文汇总了本月所有入口变更信息及使用建议。",
      date: "2026-08-05",
      readTime: 6,
      tags: ["JM最新入口", "JM网页版地址", "JM入口更新"],
      imageUrl: "https://readdy.ai/api/search-image?query=Digital%20network%20connection%20concept%20with%20glowing%20nodes%2C%20warm%20golden%20accents%2C%20minimalist%20tech%20style%2C%20soft%20gradient%20background&width=800&height=400&seq=cat-news-art2&orientation=landscape",
    },
  ],
  faq: [
    {
      id: "art-3",
      title: "JM网页版无法访问？这里有完整的解决方案",
      slug: "jm-web-access-troubleshooting",
      excerpt: "遇到JM网页版无法访问的问题？本文整理了常见的访问故障及对应的解决方案，帮助您快速恢复JM网页版的正常使用。",
      date: "2026-08-03",
      readTime: 5,
      tags: ["JM网页版地址", "JM网页版登录", "JM直达入口"],
      imageUrl: "https://readdy.ai/api/search-image?query=Technical%20support%20workspace%20with%20laptop%20displaying%20diagnostics%2C%20warm%20lighting%2C%20modern%20minimalist%20aesthetic%2C%20professional%20environment&width=800&height=400&seq=cat-faq-art3&orientation=landscape",
    },
    {
      id: "art-8",
      title: "JM网页版常见错误代码及解决方法汇总",
      slug: "jm-web-error-codes-solutions",
      excerpt: "收集整理了JM网页版使用过程中常见的错误代码提示及其对应的解决方法，帮助用户快速自助排查问题。",
      date: "2026-07-18",
      readTime: 4,
      tags: ["JM网页版", "JM最新入口", "JM直达入口"],
      imageUrl: "https://readdy.ai/api/search-image?query=Error%20code%20display%20on%20laptop%20screen%2C%20troubleshooting%20concept%2C%20warm%20office%20lighting%2C%20clean%20minimalist%20setup&width=800&height=400&seq=cat-faq-art8&orientation=landscape",
    },
  ],
  security: [
    {
      id: "art-4",
      title: "JM网页版安全使用完全手册：保护你的账号与隐私",
      slug: "jm-web-security-handbook",
      excerpt: "全面了解JM网页版的安全使用规范，学习如何保护账号安全、识别钓鱼网站、设置强密码等关键安全措施。",
      date: "2026-08-01",
      readTime: 7,
      tags: ["JM网页版官网入口", "JM安全指南", "JM官方入口"],
      imageUrl: "https://readdy.ai/api/search-image?query=Cyber%20security%20concept%20with%20shield%20and%20lock%20symbols%2C%20warm%20golden%20teal%20accents%2C%20clean%20modern%20design&width=800&height=400&seq=cat-sec-art4&orientation=landscape",
    },
  ],
  features: [
    {
      id: "art-5",
      title: "JM网页版新功能深度解析：夜间模式与快捷键操作",
      slug: "jm-web-new-features-dark-mode-shortcuts",
      excerpt: "JM网页版最新推出的夜间模式和快捷键功能详解，让您的使用体验更加舒适高效。",
      date: "2026-07-28",
      readTime: 4,
      tags: ["JM网页版", "JM功能解析", "JM网页版登录"],
      imageUrl: "https://readdy.ai/api/search-image?query=Dark%20mode%20laptop%20screen%20display%2C%20warm%20ambient%20lighting%2C%20modern%20minimalist%20workspace%2C%20soft%20glow&width=800&height=400&seq=cat-feat-art5&orientation=landscape",
    },
    {
      id: "art-6",
      title: "JM网页版与APP版功能对比：哪个更适合你？",
      slug: "jm-web-vs-app-comparison",
      excerpt: "详细对比JM网页版与APP版在功能、性能、使用场景等方面的差异，帮助你选择最适合自己的访问方式。",
      date: "2026-07-25",
      readTime: 5,
      tags: ["JM网页版", "JM官网入口", "JM直达入口"],
      imageUrl: "https://readdy.ai/api/search-image?query=Laptop%20and%20smartphone%20side%20by%20side%20on%20desk%2C%20warm%20natural%20lighting%2C%20minimalist%20setup%2C%20clean%20modern%20aesthetic&width=800&height=400&seq=cat-feat-art6&orientation=landscape",
    },
  ],
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || "tutorial");

  useEffect(() => {
    if (slug) setActiveCategory(slug);
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [activeCategory]);

  const currentCat = categoryMap[activeCategory];
  const filteredArticles = articleDataByCategory[activeCategory] || [];

  if (!currentCat) {
    return (
      <>
        <SEOHead
          title="分类未找到"
          description="您访问的分类页面不存在"
          keywords="JM网页版"
          canonicalUrl={`/category/${activeCategory}`}
        />
        <Navbar />
        <main className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-950 mb-3">
              分类未找到
            </h1>
            <Link
              to="/"
              className="text-accent-600 hover:text-accent-700 cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <SEOHead
        title={`${currentCat.name}`}
        description={currentCat.description}
        keywords={`JM网页版,JM官网入口,${currentCat.name},jm网页版教程`}
        canonicalUrl={`/category/${activeCategory}`}
      />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: "首页", href: "/" },
            { label: currentCat.name },
          ]}
        />

        <section className="py-8 md:py-12 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-xl">
                <i className={`${currentCat.icon} text-lg text-background-50`}></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  {currentCat.name}
                </h1>
                <p className="text-sm text-foreground-600">
                  {currentCat.description}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-8 flex-nowrap">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.slug
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-50 text-foreground-700 border border-background-200 hover:bg-accent-50 hover:text-accent-700 hover:border-accent-300"
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {filteredArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer"
                  >
                    <div className="h-44 w-full overflow-hidden">
                      <img
                        src={article.imageUrl}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4 md:p-5">
                      <div className="flex items-center gap-2 mb-2.5">
                        <span className="text-xs text-foreground-400">
                          {article.date}
                        </span>
                        <span className="text-xs text-foreground-400">
                          · {article.readTime}分钟阅读
                        </span>
                      </div>
                      <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-2 mt-3 pt-3 border-t border-background-200 flex-wrap">
                        {article.tags.slice(0, 3).map((tag) => (
                          <span
                            key={tag}
                            className="px-2 py-0.5 rounded-md bg-background-100 text-foreground-500 text-xs"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 flex items-center justify-center bg-background-200 rounded-2xl mx-auto mb-4">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-600">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}